import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'ja',
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    ns: ['common', 'home', 'registration', 'contact', 'courseFlow', 'levelCheck', 'wordPool', 'terms', 'privacy', 'curriculum', 'admin', 'scheduling', 'plans', 'mypage', 'profileEdit', 'postLesson', 'auth', 'addWord'],
    defaultNS: 'common',
  });

export default i18n;
